/**
 * @desc        Signup page carousel
 * @version     1.1.1 (Added translations to the carousel items, made the animation a bit smoother) - 02 July 2025
 * */

import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Carousel, CarouselIndicators, CarouselItem } from 'reactstrap'

const BackgroundCarousel = props => {
    const [activeIndex, setActiveIndex] = useState(0)
    const [animating, setAnimating] = useState(false)
    const { t } = useTranslation()

    const items = useMemo(
        () => [
            {
                src: '/assets/img/background/background-carousel-1.jpg',
                header: t('3505'),
                subtext: t('3506'),
            },
            {
                src: '/assets/img/background/background-carousel-2.jpg',
                header: t('2642'),
                subtext: t('3507'),
            },
            {
                src: '/assets/img/background/background-carousel-3.jpg',
                header: t('2636'),
                subtext: t('3508'),
            },
        ],
        [t],
    )

    const next = () => {
        if (animating) return
        const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1
        setActiveIndex(nextIndex)
    }

    const previous = () => {
        if (animating) return
        const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1
        setActiveIndex(nextIndex)
    }

    const goToIndex = newIndex => {
        if (animating) return
        setActiveIndex(newIndex)
    }

    const slides = items.map(item => {
        return (
            <CarouselItem onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)} key={item.src}>
                <div className="carousel-slide">
                    <img src={item.src} alt="" />
                    <h1 className="fs-headline">{item.header}</h1>
                    <p className="fs-base my-16">{item.subtext}</p>
                </div>
            </CarouselItem>
        )
    })

    return (
        <Carousel activeIndex={activeIndex} className="d-flex d-flex-aic" next={next} previous={previous} keyboard={false} pause={false} ride="carousel">
            {slides}
            <CarouselIndicators items={items} activeIndex={activeIndex} className="d-flex" onClickHandler={goToIndex} />
        </Carousel>
    )
}

export default BackgroundCarousel
